module.exports = __webpack_public_path__ + "img/camera_empty_height_480.dee5ba19.png";